export interface Make {
  id: number;
  name: string;
}

export interface VehicleType {
  id: number;
  name: string;
}

export interface VehicleModel {
  id: number;
  name: string;
}

export const MODEL_YEAR_RANGE = {
  min: 1900,
  max: new Date().getFullYear() + 1,
} as const;
